<template>
  <a
    href="#main-content"
    class="z-100 sr-only z-50 block rounded bg-white px-4 py-2 text-black shadow focus:not-sr-only focus:absolute focus:left-4 focus:top-4"
  >
    Hoofdmenu overslaan
  </a>
</template>
